import { DomSanitizer, SafeStyle } from '@angular/platform-browser';
import { SeQuickArtConfig } from './se-quickart-config.class';
import { IScreenElement } from './../screen-element.interface';
import { ScreenElementClass } from './../screen-element.class';
import { Subject } from 'rxjs/Subject';
import { Component, HostBinding, Injector, Input, OnInit, Output, ViewChild, HostListener, ElementRef, OnDestroy, AfterViewInit, Renderer2, ChangeDetectorRef } from '@angular/core';

// element specific config entries
@Component({
  selector: 'app-se-quickart',
  templateUrl: './se-quickart.component.html',
  styleUrls: ['./se-quickart.component.css']
})
export class SeQuickArtComponent extends ScreenElementClass implements IScreenElement, OnInit, OnDestroy, AfterViewInit {
  public elementConfig = new SeQuickArtConfig();
  public isSvg = false;
  public svgImage;

  constructor(
    public injector: Injector,
    public sanitizer: DomSanitizer,
    public elementRef: ElementRef,
    public renderer: Renderer2,
    public changeDetectorRef: ChangeDetectorRef
  ) {
    super(sanitizer); // initilize base class
    // get inital configs (if passed by injector)
    const startingElementConfig = this.injector.get('elementConfig');  // get commonConfig Value if injected

    if (startingElementConfig) {
      this.elementConfig.fromJson(startingElementConfig);
    }


  }

  async ngOnInit() {
    this.isSvg = this.elementConfig.imageURL.indexOf('.svg') > -1 ? true : false;
  }

  ngOnDestroy() {
    // Called once, before the instance is destroyed.
    // Add 'implements OnDestroy' to the class.
  }

  async ngAfterViewInit() {
    this.onElementReadySubject.next(this);
  }

  update() {
    if (this.elementConfig) {
      const imgPath = this.elementConfig.imageURL;

      this.elementConfig.imageURL = '';

      this.changeDetectorRef.detectChanges();

      process.nextTick(() => {
        if (this.svgImage) {
          const bbox = this.svgImage.getBBox();
          if (bbox.height > 0 && bbox.width > 0) {
            this.svgImage.setAttribute('viewBox', `${bbox.x} ${bbox.y} ${bbox.width + (this.elementConfig.borderWidth * 2)} ${bbox.height + (this.elementConfig.borderWidth * 2)}`);
          }
        }
      });
    }
  }

  onSVGInserted(svgElement) {
    const bbox = svgElement.getBBox();
    if (bbox.height > 0 && bbox.width > 0) {
      svgElement.setAttribute('viewBox', `${bbox.x} ${bbox.y} ${bbox.width + (this.elementConfig.borderWidth * 2)} ${bbox.height + (this.elementConfig.borderWidth * 2)}`);
    }
    svgElement.setAttribute('preserveAspectRatio', 'none');
  }

  getCustomProperties() {
    const props = [
      {
        prop: {
          name: 'Image',
          controlComponent: 'imagepicker',
          propPath: 'elementConfig.imageURL'
        }
      }
    ];
    return props;
  }



}



// WEBPACK FOOTER //
// ./src/app/backend-main.module/pages/designer.module/screen-elements.module/se-quickart/se-quickart.component.ts